export const fetchAllPatientsUrl = 'patients';
